<template>
  <div class="form-group mb-0">
    <div class="select-jumbo">
      <select style="background: white;" v-model="selectedTime" @change="updateTime">
        <option :value="time" v-for="time, index in availableTimes">{{ time }}</option>
      </select>
      <span class="far fa-clock input-text-icon"></span>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone'

  export default {
    props: {
      mapDatesTimes: Object,
      selectedDate: Date,
      availableTimes: Array
    },
    data () {
      return {
        selectedTime: null
      }
    },
    watch: {
      selectedDate () {
        const fmDate = this.getFormattedDate(this.selectedDate)
        if (this.mapDatesTimes.hasOwnProperty(fmDate)) {
          this.selectedTime = this.mapDatesTimes[fmDate]
        } else {
          this.selectedTime = this.availableTimes[0]
        }
      }
    },
    methods: {
      getFormattedDate (date) {
        return moment(date).format('YYYY-MM-DD').toString()
      },
      updateTime () {
        this.$emit('selectTime', this.selectedDate, this.selectedTime)
      }
    },
    mounted () {
      this.selectedTime = this.availableTimes[0]
      this.updateTime()
    }
  }
</script>

<style scoped>
  .input-text-icon {
    float: right;
    margin-right: 0.5rem;
    margin-top: -1.65rem;
    position: relative;
    font-size: 120%;
    z-index: 2;
    color: #9E9E9E;
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/ProfessionalTimeSelection.vue